<script>
    import { createEventDispatcher } from 'svelte';

    export let foodName = "Food"
    export let image = "images/foodimages/generalfood.jpg";

    let mouseX = 0;
    let mouseDisplacementX = 0;
    let elem = null;
    let isTouch = false;
    const dispatch = createEventDispatcher();

    function MoveItemMouse(e){
        e = e || window.event;
        e.preventDefault();
        mouseDisplacementX += (e.clientX - mouseX);
        if(mouseDisplacementX >= 200){
            dispatch('sway', {
		        text: 'r'
	        });
        }
        else if(mouseDisplacementX <= -200){
            dispatch('sway', {
		        text: 'l'
	        });
        }
        else{
            dispatch('sway', {
		        text: 'off'
	        });
        }
        mouseX = e.clientX;
    }
    function MoveItemTouch(e){
        e = e || window.event;
        var touch = e.touches[0];
        mouseDisplacementX += (touch.pageX - mouseX);
        if(mouseDisplacementX >= 50){
            dispatch('sway', {
		        text: 'r'
	        });
        }
        else if(mouseDisplacementX <= -50){
            dispatch('sway', {
		        text: 'l'
	        });
        }
        else{
            dispatch('sway', {
		        text: 'off'
	        });
        }
        mouseX = touch.pageX;
    }
    function GetMousePosition(e){
        isTouch = false;
        elem = document.getElementById("draggable");
        e = e || window.event;
        mouseX = e.clientX;
        document.onmousemove = MoveItemMouse;
        document.onmouseup = closeDragElement;
    }
    function closeDragElement() {
        document.onmouseup = null;
        document.onmousemove = null;
        document.ontouchmove = null;
        document.ontouchend = null;
        let limit = isTouch ? 50 : 200;
        if(mouseDisplacementX >= limit){
            dispatch('sway', {
		        text: 'rend'
	        });
        }
        else if(mouseDisplacementX <= -limit){
            dispatch('sway', {
		        text: 'lend'
	        });
        }
        else{
            dispatch('sway', {
		        text: 'off'
	        });
        }
        mouseDisplacementX = 0;
        
    }
    function GetTouchPosition(e){
        isTouch = true;
        elem = document.getElementById("draggable");
        e = e || window.event;
        var touch = e.touches[0];
        mouseX = touch.pageX
        document.ontouchmove = MoveItemTouch;
        document.ontouchend = closeDragElement;
    }
    function FlipElement(){
        dispatch('view', {
		    text: 'c'
	    });
    }
</script>

<style>
    #draggable{
        display: flex;
		justify-content: center;
		align-content: center;
		align-items: center;
    }
    .base{
        background-color: #1B1B1B;
        color: whitesmoke;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-around;
        border-radius: 5em;
        min-height: 80vh;
        margin-top: 5vh;
        margin-bottom: 10vh;
        padding-left: 7vw;
        padding-right: 7vw;
        min-width: 30vw;
        width: 50vw;
    }
    .foodpic{
        width: 15em;
        height: 15em;
        border-color: white;
        border-style: solid;
        border-width: 0.2em;
        border-radius: 1em;
        user-select: none;
    }
    .foodName{
        color: whitesmoke;
        font-size: 55px;
        margin: 0;
        user-select: none;
    }
    .viewdetails{
        color: whitesmoke;
        font-size: 2em;
        align-self: center;
        user-select: none;
    }
    .eye{
        width: 10em;
        height: 4em;
        align-self: center;
        user-select: none;
    }

    @media only screen and (max-width: 900px) {
        .foodpic{
            width: 13.5em;
            height: 13.5em;
            border-width: 0.133em;
        }
        .foodName{
            font-size: 50px;
            margin: 0;
        }
        .base{
            border-radius: 5em;
            padding-left: 10vw;
            padding-right: 10vw;
            margin-top: 5vh;
            margin-bottom: 10vh;
            min-height: 80vh;
            height: 80vh;
        }
        
    }
    @media only screen and (max-width: 700px) {
        .eye{
            width: 8em;
            height: 4em;
        }
        .foodpic{
            width: 12em;
            height: 12em;
        }
        .foodName{
            font-size: 2.5em;
            margin: 0;
        }
        .base{
            border-radius: 5em;
            margin-top: 3.5vh;
            margin-bottom: 7vh;
            min-height: 80vh;
            max-width: 70vw;
            height: 80vh;
        }
    }
    @media only screen and (max-width: 400px) {
        .eye{
            width: 5em;
            height: 3em;
            align-self: center;
            justify-self: flex-end;
        }
        .foodpic{
            width: 10em;
            height: 10em;
        }
        .foodName{
            color: whitesmoke;
            font-size: 2.75em;
            margin: 0;
        }
        .base{
            border-radius: 2em;
            margin-top: 3.5vh;
            margin-bottom: 7vh;
            min-height: 80vh;
            height: 80vh;
        }
    }
    .viewbutton{
        background-color: transparent;
        border: none;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-content: center;
    }
    .viewbutton:focus{
        background-color: transparent;
        border: none;
    }
</style>

<body on:load{GetElem()} >
    <div on:mousedown={GetMousePosition} on:touchstart={GetTouchPosition} id="draggable" >
        <div class="base">
            <p class="foodName">{foodName}</p>
            <img src={image} alt="{foodName} Picture" class="foodpic">
            <div class="viewcontainer">
                <button on:click={FlipElement} class="viewbutton">
                    <img src="images/EyeView.svg" alt="View Details" class="eye">
                    <p class="viewdetails">View Details</p>
                </button>
            </div>
        </div>
    </div>
</body>